import React from "react";
import { Box, Typography } from "@mui/material";
import { TEXT_COLOR_PRIMARY } from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";

/**
 * 資格一覧の1項目表示
 *
 * - 左：取得年月
 * - 右：資格名
 */
const QualificationItem = ({ qualification }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "80px 1fr",
      }}
    >
      <Typography sx={{ color: TEXT_COLOR_PRIMARY, fontSize: FONT_SIZE.SM }}>
        {qualification.acquired_at}
      </Typography>

      <Typography sx={{ color: TEXT_COLOR_PRIMARY, fontSize: FONT_SIZE.SM }}>
        {qualification.name}
      </Typography>
    </Box>
  );
};

export default QualificationItem;
